"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@nivo/core");

var _colors = require("@nivo/colors");

var _legends = require("@nivo/legends");

var _props = require("./props");

var _canvas = require("./canvas");

var _PieTooltip = _interopRequireDefault(require("./PieTooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class PieCanvasRenderer extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getArcFromMouse", event => {
      const _getRelativeCursor = (0, _core.getRelativeCursor)(this.surface, event),
            x = _getRelativeCursor[0],
            y = _getRelativeCursor[1];

      const _this$props = this.props,
            centerX = _this$props.centerX,
            centerY = _this$props.centerY,
            margin = _this$props.margin,
            radius = _this$props.radius,
            innerRadius = _this$props.innerRadius,
            arcs = _this$props.arcs;
      return (0, _core.getHoveredArc)(margin.left + centerX, margin.top + centerY, radius, innerRadius, arcs, x, y);
    });

    _defineProperty(this, "handleMouseHover", (showTooltip, hideTooltip) => event => {
      if (this.props.isInteractive !== true) return;
      const arc = this.getArcFromMouse(event);

      if (arc) {
        showTooltip(_react.default.createElement(_PieTooltip.default, {
          data: arc.data,
          color: arc.color,
          theme: this.props.theme
        }), event);
      } else {
        hideTooltip();
      }
    });

    _defineProperty(this, "handleMouseLeave", hideTooltip => () => {
      if (this.props.isInteractive !== true) return;
      hideTooltip();
    });

    _defineProperty(this, "handleClick", event => {
      const arc = this.getArcFromMouse(event);
      if (arc) this.props.onClick(arc.data, event);
    });
  }

  componentDidMount() {
    this.ctx = this.surface.getContext('2d');
    this.draw(this.props);
  }

  shouldComponentUpdate(props) {
    // only update if the DOM needs to be updated
    if (this.props.outerWidth !== props.outerWidth || this.props.outerHeight !== props.outerHeight || this.props.isInteractive !== props.isInteractive || this.props.theme !== props.theme) {
      return true;
    }

    this.draw(props);
    return false;
  }

  componentDidUpdate() {
    this.ctx = this.surface.getContext('2d');
    this.draw(this.props);
  }

  draw(props) {
    const arcs = props.arcs,
          arcGenerator = props.arcGenerator,
          width = props.width,
          height = props.height,
          centerX = props.centerX,
          centerY = props.centerY,
          radius = props.radius,
          outerWidth = props.outerWidth,
          outerHeight = props.outerHeight,
          pixelRatio = props.pixelRatio,
          margin = props.margin,
          borderWidth = props.borderWidth,
          borderColor = props.borderColor,
          enableSlicesLabels = props.enableSlicesLabels,
          enableRadialLabels = props.enableRadialLabels,
          legends = props.legends,
          theme = props.theme;
    this.surface.width = outerWidth * pixelRatio;
    this.surface.height = outerHeight * pixelRatio;
    this.ctx.scale(pixelRatio, pixelRatio);
    this.ctx.fillStyle = theme.background;
    this.ctx.fillRect(0, 0, outerWidth, outerHeight);
    this.ctx.save();
    this.ctx.translate(margin.left, margin.top);
    arcGenerator.context(this.ctx);
    this.ctx.save();
    this.ctx.translate(centerX, centerY);
    const getBorderColor = (0, _colors.getInheritedColorGenerator)(borderColor, theme);
    arcs.forEach(arc => {
      this.ctx.beginPath();
      this.ctx.fillStyle = arc.color;
      this.ctx.strokeStyle = getBorderColor(_extends({}, arc.data, {
        color: arc.color
      }));
      this.ctx.lineWidth = borderWidth;
      arcGenerator(arc);
      this.ctx.fill();
      if (borderWidth > 0) this.ctx.stroke();
    });

    if (enableSlicesLabels === true) {
      const sliceLabel = props.sliceLabel,
            slicesLabelsSkipAngle = props.slicesLabelsSkipAngle,
            slicesLabelsTextColor = props.slicesLabelsTextColor;
      (0, _canvas.drawSliceLabels)(this.ctx, arcs, {
        arcGenerator,
        skipAngle: slicesLabelsSkipAngle,
        getLabel: (0, _core.getLabelGenerator)(sliceLabel),
        getTextColor: (0, _colors.getInheritedColorGenerator)(slicesLabelsTextColor, theme),
        theme
      });
    }

    if (enableRadialLabels === true) {
      const radialLabel = props.radialLabel,
            radialLabelsSkipAngle = props.radialLabelsSkipAngle,
            radialLabelsLinkOffset = props.radialLabelsLinkOffset,
            radialLabelsLinkStrokeWidth = props.radialLabelsLinkStrokeWidth,
            radialLabelsLinkDiagonalLength = props.radialLabelsLinkDiagonalLength,
            radialLabelsLinkHorizontalLength = props.radialLabelsLinkHorizontalLength,
            radialLabelsTextXOffset = props.radialLabelsTextXOffset,
            radialLabelsTextColor = props.radialLabelsTextColor,
            radialLabelsLinkColor = props.radialLabelsLinkColor;
      (0, _canvas.drawRadialLabels)(this.ctx, arcs, {
        radius,
        getLabel: (0, _core.getLabelGenerator)(radialLabel),
        skipAngle: radialLabelsSkipAngle,
        linkOffset: radialLabelsLinkOffset,
        linkDiagonalLength: radialLabelsLinkDiagonalLength,
        linkHorizontalLength: radialLabelsLinkHorizontalLength,
        linkStrokeWidth: radialLabelsLinkStrokeWidth,
        textXOffset: radialLabelsTextXOffset,
        getTextColor: (0, _colors.getInheritedColorGenerator)(radialLabelsTextColor, theme),
        getLinkColor: (0, _colors.getInheritedColorGenerator)(radialLabelsLinkColor, theme),
        theme
      });
    }

    this.ctx.restore();
    legends.forEach(legend => {
      (0, _legends.renderLegendToCanvas)(this.ctx, _extends({}, legend, {
        data: arcs.map(arc => ({
          id: arc.data.id,
          label: arc.data.id,
          color: arc.color
        })),
        containerWidth: width,
        containerHeight: height,
        theme
      }));
    });
  }

  render() {
    const _this$props2 = this.props,
          outerWidth = _this$props2.outerWidth,
          outerHeight = _this$props2.outerHeight,
          pixelRatio = _this$props2.pixelRatio,
          isInteractive = _this$props2.isInteractive,
          theme = _this$props2.theme;
    return _react.default.createElement(_core.Container, {
      isInteractive: isInteractive,
      theme: theme,
      animate: false
    }, ({
      showTooltip,
      hideTooltip
    }) => _react.default.createElement("canvas", {
      ref: surface => {
        this.surface = surface;
      },
      width: outerWidth * pixelRatio,
      height: outerHeight * pixelRatio,
      style: {
        width: outerWidth,
        height: outerHeight
      },
      onMouseEnter: this.handleMouseHover(showTooltip, hideTooltip),
      onMouseMove: this.handleMouseHover(showTooltip, hideTooltip),
      onMouseLeave: this.handleMouseLeave(hideTooltip),
      onClick: this.handleClick
    }));
  }

}

PieCanvasRenderer.propTypes = process.env.NODE_ENV !== "production" ? {
  arcs: _propTypes.default.arrayOf(_props.arcPropType).isRequired,
  arcGenerator: _propTypes.default.func.isRequired,
  // resolution
  pixelRatio: _propTypes.default.number.isRequired,
  // dimensions/layout
  outerWidth: _propTypes.default.number.isRequired,
  outerHeight: _propTypes.default.number.isRequired,
  centerX: _propTypes.default.number.isRequired,
  centerY: _propTypes.default.number.isRequired,
  margin: _propTypes.default.object.isRequired,
  radius: _propTypes.default.number.isRequired,
  innerRadius: _propTypes.default.number.isRequired,
  // interactivity
  isInteractive: _propTypes.default.bool.isRequired,
  onClick: _propTypes.default.func.isRequired,
  // theming
  theme: _propTypes.default.object.isRequired
} : {};
var _default = PieCanvasRenderer;
exports.default = _default;
module.exports = exports.default;